import _ from 'lodash'
import integrationExchangeApi from '@/api/integration-exchange'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  loading: false,

  stats: [],
  statsLoading: false,

  details: null,
  detailsLoading: false,

  filters: {
    pageNumber: 1,
    pageSize: 25,
    sortBy: 'createdAt',
    sortDesc: true,
    sources: [],
    dateFrom: null,
    dateTo: null,
    orderId: null,
    onlyFailed: false,
    slowerThanMs: null,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    commit('LIST_LOADING')

    return integrationExchangeApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
      .catch(() => commit('SET_LIST', { items: [], metadata: { totalItemCount: 0 } }))
  },

  fetchStats({ commit }) {
    commit('STATS_LOADING')

    const {
 sources, dateFrom, dateTo, orderId, onlyFailed, slowerThanMs,
} = state.filters

    return integrationExchangeApi.getStats({
 sources, dateFrom, dateTo, orderId, onlyFailed, slowerThanMs,
})
      .then(({ data }) => commit('SET_STATS', data))
      .catch(() => commit('SET_STATS', []))
  },

  async fetchDetails({ commit }, id) {
    commit('DETAILS_LOADING')

    try {
      const { data } = await integrationExchangeApi.getById(id)
      commit('SET_DETAILS', data)
    } catch {
      commit('SET_DETAILS', null)
      store.dispatch('message/error', 'Не удалось открыть запись')
    }
  },

  closeDetails({ commit }) {
    commit('SET_DETAILS', null)
  },
}

const mutations = {
  LIST_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  STATS_LOADING(state) {
    state.statsLoading = true
  },
  SET_STATS(state, data) {
    state.stats = data || []
    state.statsLoading = false
  },
  DETAILS_LOADING(state) {
    state.detailsLoading = true
  },
  SET_DETAILS(state, data) {
    state.details = data
    state.detailsLoading = false
  },
  ...generateFormHandlerMutations(state),
}

const watchers = [
  [
    state => state.integrationExchange.filters,
    _.debounce(async () => {
      await store.dispatch('integrationExchange/fetchList')
      await store.dispatch('integrationExchange/fetchStats')
    }, 250),
    { immediate: false, deep: true },
  ],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  watchers,
}
